export const getVideoId = (url: string) => {
    if (!url) return ``;
    const [id] = url.split(`/`).slice(-1);
    return id;
};
